function configureAttribution(options) {
  const forms = document.querySelectorAll('form');

  forms.forEach((form) => {
    if (!form || !form.action || !form.action.includes('/cart/add')) {
      return;
    }

    let formInput = form.querySelector('input[name="properties[_attribution]"]');
    if (!formInput) {
      formInput = document.createElement('input');
      formInput.type = 'hidden';
      formInput.name = 'properties[_attribution]';
      form.appendChild(formInput);
    }
    formInput.value = JSON.stringify(options);
  });
}
